<template>
  <!-- 编辑轮播图 -->
  <el-dialog title="轮播图管理"
             :visible.sync="editCarouselShow.show"
             width="1000px"
             :before-close="handleClose">
    <div class="edit_carousel">
      <div class="edit_carousel_top">
        <el-image :src="item.thumb"
                  @click="getActiverClick(item,index)"
                  fit='cover'
                  v-for="(item,index) in index_carousel"
                  :key="item.id"
                  :class="editSelectIndex==index?'activeClassImage':''"></el-image>
        <div class="addNewCarousel"
             @click="getActiverClick({},'add')"
             :class="editSelectIndex=='add'?'activeClassImage':''">
          <i class="el-icon-plus"></i>
        </div>
      </div>
      <div class="edit_carousel_bottom">
        <el-form :model="editSelectData"
                 v-if="editSelectIndex!='add'"
                 label-position="top"
                 ref="editSelectData">
          <el-form-item label="更换图片"
                        style="width:100%">
            <el-upload class="upload-demo"
                       :action="upUrl"
                       :show-file-list="false"
                       :before-upload="detection_up_data"
                       :on-success="slideshow_success"
                       :multiple='false'>
              <el-button size="small"
                         type="primary">点击上传</el-button>
            </el-upload>

          </el-form-item>

          <el-form-item label="图片标题"
                        prop="title">
            <el-input v-model="editSelectData.title"
                      @blur="editCarousel"
                      placeholder="请输入图片的标题"></el-input>
          </el-form-item>

          <el-form-item label="跳转链接(为空不跳转)">
            <el-input v-model="editSelectData.linkurl"
                      @blur="editCarousel"
                      placeholder="请输入跳转的链接"></el-input>
          </el-form-item>
          <el-form-item label="排序值（越大越在前）">
            <el-input-number v-model="editSelectData.displayorder"
                             controls-position="right"
                             :min="1"
                             size="mini"
                             @blur="editCarousel"
                             :max="10000"></el-input-number>
          </el-form-item>
          <el-form-item label="删除此图片">
            <el-button size="mini"
                       type="danger"
                       @click="removeImage">点击删除</el-button>
          </el-form-item>

        </el-form>
        <el-form :model="editSelectData"
                 v-else
                 label-position="top"
                 ref="editSelectData">
          <el-form-item label="更换图片"
                        style="width:100%">
            <el-upload class="avatar-uploader"
                       :action="upUrl"
                       :show-file-list="false"
                       :multiple='false'
                       :on-success="(res)=>{slideshow_success(res,true)}"
                       :before-upload="detection_up_data">
              <img v-if="editSelectData.thumb"
                   :src="editSelectData.thumb"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>

          <el-form-item label="图片标题">
            <el-input v-model="editSelectData.title"
                      placeholder="请输入图片的标题"></el-input>
          </el-form-item>

          <el-form-item label="跳转链接(为空不跳转)">
            <el-input v-model="editSelectData.linkurl"
                      placeholder="请输入跳转的链接"></el-input>
          </el-form-item>
          <el-form-item label="排序值（越大越在前）">
            <el-input-number v-model="editSelectData.displayorder"
                             controls-position="right"
                             :min="1"
                             size="mini"
                             :max="10000"></el-input-number>
          </el-form-item>

          <el-form-item label="最后一步">
            <el-button size="medium"
                       type="primary"
                       @click="saveVerification ">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import { apiGetLanternSlide, apiDelectLanternSlide, } from '@/request/api'
export default {
  data () {
    return {
      // ---------------------上传地址-------------
      upUrl: '',
      // ---------------------编辑首页轮播图模块数据弹窗-选择的数据-------------
      editSelectData: {},
      // ---------------------编辑首页轮播图模块数据弹窗-选择的index-------------
      editSelectIndex: 0,
      marketingWebData: ''
    }
  },
  props: {
    editCarouselShow: {
      type: Object,
      default: {}
    },
    index_carousel: {
      require: true,
      type: Array
    }
  },
  methods: {

    // --------------------初始化选择的数据--------------
    initializeSelectData (data, mdata) {
      this.editSelectData = data
      this.marketingWebData = mdata
    },
    // --------------------删除幻灯片数据--------------
    async removeImage () {
      await apiDelectLanternSlide({
        siteid: this.marketingWebData.id,
        id: this.editSelectData.id
      })
      this.$emit('collapse_change', 'carousel')
    },
    // --------------------保存数据验证--------------
    async saveVerification () {
      if (this.editSelectData.displayorder == '') {
        return this.$message('请填写排序')
      } else if (this.editSelectData.thumb == '') {
        return this.$message('请上传图片')
      }
      await this.editCarousel()
      this.$emit('collapse_change', 'carousel')
      this.editSelectIndex = 0
      this.$set(this, 'editSelectData', {})
    },
    // --------------------- 发起请求编辑轮播图 -------------
    async editCarousel () {
      let res = await apiGetLanternSlide({
        siteid: this.marketingWebData.id,
        type: 1,
        ...this.editSelectData
      })
      this.$message(res.message)
    },
    // --------------------上传成功回调--------------
    slideshow_success (res, falg) {
      if (res.url) {
        this.$set(this.editSelectData, 'thumb', res.url)
        if (!falg) {
          this.editCarousel()
        }

      }
    },
    // --------------------检测上传--------------
    detection_up_data (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG / PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传轮播图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    },
    // ---------------------关闭确认-------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // --------------------- 获取单前点击的元素 -------------
    getActiverClick (item, index) {
      this.editSelectIndex = index
      this.editSelectData = item
    },
  },
  created () {
    this.upUrl = this.$store.state.upUrl;

  }
}
</script>

<style lang='scss'>
.edit_carousel {
  width: 100%;
  display: flex;
  flex-direction: column;
  .edit_carousel_top {
    width: 100%;
    flex: 1;
    max-height: 300px;
    display: flex;
    .activeClassImage {
      border-color: #409eff !important;
      color: #409eff !important;
    }
    .el-image,
    .addNewCarousel {
      width: 200px;
      height: 200px;
      margin-right: 10px;
      border: 1px dashed #999;
      border-radius: 4px;
      cursor: pointer;
      padding: 4px;
    }
    .el-image:hover {
      border-color: #409eff;
    }
    .addNewCarousel:hover {
      border-color: #409eff;
      color: #409eff;
    }
    .addNewCarousel {
      // border-color: #67c23a;
      // color: #67c23a;
      transition: all 0.3s;
      font-size: 4em;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-image:last-child {
      margin: 0;
    }
  }
  .edit_carousel_bottom {
    flex: 1;
    background-color: #f5f5f5;
    margin-top: 10px;
    border-radius: 4px;
    padding: 20px;
    .addImage_view {
      width: 200px;
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #999;
      border-radius: 4px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 40%;
        margin-right: 10px;
      }
    }
  }
}
</style>